<template>
  <vs-popup title="Détails de la consultation" :active.sync="isPromptActiveLocal">
    <vs-row>
      <vs-col vs-w="6">
        <div>Code Consultation</div>
        <div><strong>{{ information.code }}</strong></div>
      </vs-col>
      <vs-col vs-w="6">
        <div>Numéro Payeur</div>
        <div><strong>{{ information.phone }}</strong></div>
      </vs-col>
    </vs-row><br>

    <vs-row>
      <vs-col vs-w="6">
        <div>Statut</div>
        <div>
          <vs-chip v-if="information.status == 'to_validate'" color="success">Validée</vs-chip>
          <vs-chip v-if="information.status == 'to_canceled'" color="danger">Annulée</vs-chip>
          <vs-chip v-if="information.status == 'expired'" color="danger">Expirée</vs-chip>
          <vs-chip v-if="information.status == 'paid'">Nouveau</vs-chip>
        </div>
      </vs-col>
      <vs-col vs-w="6">
        <div>Nom & Prénom</div>
        <div><strong>{{ information.last_name ? information.last_name : '' }} {{ information.first_name ? information.first_name : '' }}</strong></div>
      </vs-col>
    </vs-row><br>

    <vs-row>
      <vs-col vs-w="6">
        <div>Spécialité</div>
        <div><strong>{{ information.speciality }}</strong></div>
      </vs-col>
      <vs-col vs-w="6">
        <div>
          <span v-if="information.status == 'to_validate'">Validée par</span>
          <span v-if="information.status == 'to_canceled'">Annulée par</span>
        </div>
        <div><strong>{{ information.validateur ? information.validateur : '' }}</strong></div>
      </vs-col>
    </vs-row><br>

    <vs-row>
      <vs-col vs-w="6">
        <div>Montant payé</div>
        <div><strong>{{ parseFormat(information.amount) }}</strong></div>
      </vs-col>
      <vs-col vs-w="6">
        <div>
          <span>Validée le</span>
        </div>
        <div>
          <strong>{{ information.validated_at ? parseDate(information.validated_at) : '' }}</strong>
        </div>
      </vs-col>
    </vs-row><br>

    <vs-row>
      <vs-col vs-w="6">
        <div>Annulée le</div>
        <div><strong>{{ information.canceled_at ? parseDate(information.canceled_at) : '' }}</strong></div>
      </vs-col>
      <vs-col vs-w="6">
        <div>
          <span>Expirée le</span>
        </div>
        <div>
          <strong>{{ information.expiry_at ? parseDateFormat(information.expiry_at) : '' }}</strong>
        </div>
      </vs-col>
    </vs-row><br>


    <vs-row>
      <vs-col vs-w="6">
        <div>Date & heure de paiement</div>
        <div><strong>{{ information.paid_at ? parseDate(information.paid_at) : '' }}</strong></div>
      </vs-col>
      <vs-col vs-w="6">
        <div>Praticien</div>
        <div><strong>{{ information.praticien }}</strong></div>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
  import { format } from '../../../helper/helper'
  import moment from 'moment'
    export default {
      name: "detail",
      props: {
        information: {
          type: Object
        },
        isPromptActive: {
          type: Boolean,
          required: true
        },
      },
      watch: {
        isPromptActive(val) {
          if (!val) return;
        }
      },
      computed: {
        isPromptActiveLocal: {
          get() {
            return this.isPromptActive
          },
          set(val) {
            if (!val) {
              this.$emit('closePrompt')
            }
          }
        },
      },
      methods:{
        parseFormat(amount){
          if (amount != '' && amount != null){
            return format(amount) + ' Fcfa'
          }
        },
        parseDate(date){
          return moment(date).format('DD-MM-YYYY H:mm')
        },
        parseDateFormat(date){
          return moment(date).format('DD-MM-YYYY')
        }
      }
    }
</script>

<style scoped>

</style>
